import { Form, Tooltip } from 'antd';
import React from 'react';
import FilterDropdown from '../FilterDropdown/FilterDropdown';

const FilterDropdownField = ({ config }) => {
  return (
    <Form.Item
      label={config.placeholder}
      style={{ margin: 0 }}
    >
      <Tooltip title={config.disabled ? config.disabledText || '' : ''}>
        <div>
          <FilterDropdown
            config={config}
            isMultiple={config.isMultiple}
            isClear={config.isClear}
          />
        </div>
      </Tooltip>
    </Form.Item>
  );
};

export default FilterDropdownField;
